import { cn } from "@/common/utils/css.utils";
import { PropsWithChildren } from "react";

type PasswordStrengthEntryMessageProps = {
  state?: "default" | "valid" | "invalid";
};

export const PasswordStrenghtEntryMessage = ({
  state,
  children,
}: PropsWithChildren<PasswordStrengthEntryMessageProps>) => {
  return (
    <span
      className={cn("text-sm", {
        "text-brand-500": state === "valid",
        "text-attention-500": state === "invalid",
        "text-grey-500": !state || state === "default",
      })}
    >
      {children}
    </span>
  );
};
